import Vue from 'vue'
import Router from 'vue-router'
import LoginView from '../components/LoginView'
import MainView from '../components/MainView'
import RegView from '../components/RegisterView'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: MainView
    },
    {
      path: '/index',
      name: 'Main',
      component: MainView
    },
    {
      path: '/register/:token?',
      name: 'Register',
      meta: {
        requireAuth: true
      },
      component: RegView
    }
  ],
  mode:'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js